import Pikaday from 'pikaday'

export default {
  name: 'datepicker',

  ui: {
    input: '[js-datepicker]',
  },

  componentDidMount () {
    const $picker = document.querySelector('.js-datepicker')
    let i18n = {
      previousMonth: 'Mois précédent',
      nextMonth: 'Le mois prochain',
      months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
      weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
      weekdaysShort: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
    }

    if (document.documentElement.lang === 'en') {
      i18n = {
        previousMonth: 'Previous Month',
        nextMonth: 'Next Month',
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        weekdaysShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      }
    }

    const pickday = new Pikaday({
      field: $picker,
      format: 'D/MM/YYYY',
      firstDay: 1,
      disableDayFn: function (gdate) {
        const currentDate = new Date()

        if (gdate < currentDate) {
          return true
        }
        return false
      },
      i18n: i18n,
    })
    if (pickday) {
      pickday.gotoToday()
    }
  },
}
